const topics = [
  { name: '娱乐圈黑料', count: '328', hot: true },
  { name: '网红塌房', count: '256', hot: true },
  { name: '明星恋情', count: '192', hot: false },
  { name: '大厂内幕', count: '245', hot: true },
  { name: '财经黑幕', count: '167', hot: false },
  { name: '体育争议', count: '143', hot: false },
  { name: '学术造假', count: '98', hot: false },
  { name: '选秀黑幕', count: '175', hot: true },
  { name: '品牌翻车', count: '134', hot: false },
  { name: '直播带货', count: '289', hot: true },
  { name: '社会热点', count: '312', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          当前最受关注的吃瓜话题标签，点击探索更多黑料故事
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className={`relative flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 ${
                topic.hot
                  ? 'bg-primary-500/10 border-primary-500/30 hover:bg-primary-500/20 hover:border-primary-500/50'
                  : 'bg-background-50 border-background-300/50 hover:bg-background-200 hover:border-background-400/50'
              }`}
            >
              {topic.hot && (
                <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse flex-shrink-0"></span>
              )}
              <span className={`text-sm font-medium whitespace-nowrap ${topic.hot ? 'text-primary-300' : 'text-foreground-300'}`}>
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}